import React, { useEffect } from 'react';
import { Form, useFormikContext, withFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { BUSINESS_NAME_ERROR_MESSAGE } from '../validation-utils';
import { ErrorList } from '../components/ErrorList';
import * as Yup from 'yup';
import { InputBox } from '../components';

const BusinessNameSchema = Yup.object().shape({
  provider: Yup.object().shape({
    organisation_name: Yup.string().required(BUSINESS_NAME_ERROR_MESSAGE),
  }),
});

const formikWrapper = withFormik({
  mapPropsToValues: (props) => ({
    ...props.initialValues,
  }),
  validationSchema: BusinessNameSchema,
  validateOnMount: false,
  validateOnBlur: false,
  validateOnChange: false,
  handleSubmit: (values, formikBag) => {
    values.matomo.trackEvent({
      category: 'Business Name',
      action: 'Completed',
    });
    delete values.matomo;
    let next = 'about-incident';
    if (values.editMode) {
      next = 'review-answers';
    }
    values.sections.add('business-name');
    formikBag.props.updateValues(values, next);
  },
});

const BusinessName = ({ setFieldValue, values }) => {
  const formik = useFormikContext();
  const history = useHistory();
  const { trackPageView, trackEvent } = useMatomo();
  formik.values.matomo = { trackEvent };

  useEffect(() => {
    trackPageView({
      documentTitle: 'Business Name - Report Suspicious Chemical Activity'
    });
    trackEvent({
      category: 'Business Name',
      action: 'Started',
    });
  }, []);

  return (
    <div>
      <a
        className="govuk-back-link"
        href="#"
        onClick={() => {
          if (!values.editMode) {
            setFieldValue(`sections`, values.sections.delete(`business-name`));
          }
          history.goBack();
        }}
      >
        Back
      </a>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-full">
            <ErrorList />
            <Form autoComplete="on" onSubmit={formik.handleSubmit}>
              <div className="govuk-grid-column">
                <InputBox
                  name="provider.organisation_name"
                  subText={'Enter the name of the business you own or work for'}
                  hintId="organisation_name"
                  questionLarge={'Name of the business'}
                />
              </div>
              <button
                type="submit"
                data-prevent-double-click="true"
                className="govuk-button"
                data-module="govuk-button"
                data-test={`button-continue`}
                aria-label={'Continue'}
              >
                Continue
              </button>
            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};

const BusinessNameWithFormik = formikWrapper(BusinessName);

export { BusinessNameWithFormik as BusinessName };
